/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="127.95"
        height="68.95"
        viewBox="0 0 127.95 68.95"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#0e497b"
          d="M61.83 47.49a1.24 1.24 0 0 1 1.64.27l.08.11 7.86 12.33a4.21 4.21 0 0 0 5.78 1.43A4.4 4.4 0 0 0 78.83 56a1.25 1.25 0 0 1 2.2-1.18 6.88 6.88 0 0 1-2.58 9 6.71 6.71 0 0 1-9-2.08l-.12-.2-7.84-12.3a1.24 1.24 0 0 1 .34-1.75Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M52.98 54.11a1.25 1.25 0 0 1 1.65.27l.08.11 5 7.89a4.21 4.21 0 0 0 5.79 1.43 4.4 4.4 0 0 0 1.64-5.61 1.25 1.25 0 1 1 2.2-1.18 6.88 6.88 0 0 1-2.58 9 6.71 6.71 0 0 1-9-2.08l-.13-.2-5-7.86a1.25 1.25 0 0 1 .35-1.77ZM64.05 2.39a1.25 1.25 0 0 1 0 2.5A8.84 8.84 0 0 0 57.28 8l-.19.23L44.2 25.08a4.77 4.77 0 0 0-1 2.9 4.86 4.86 0 0 0 4.88 4.84 4.91 4.91 0 0 0 3.32-1.29l.19-.18 12.12-12.26a3.23 3.23 0 0 1 2.24-.89h.29l3.49.32 2.13.18h.76a4.49 4.49 0 0 1 3.51 2.3l.11.2 16.8 32a6.9 6.9 0 0 1-2.59 9 6.71 6.71 0 0 1-9-2.07l-.12-.21-11-17.26a1.25 1.25 0 0 1 2-1.45l.08.11 11 17.3a4.22 4.22 0 0 0 5.78 1.43 4.42 4.42 0 0 0 1.73-5.43l-.11-.23-16.79-32a2 2 0 0 0-1.44-1.07h-.16l-2-.16-4.41-.39h-.06a.8.8 0 0 0-.42.12l-.08.06L53.4 33.1A7.39 7.39 0 0 1 40.73 28a7.26 7.26 0 0 1 1.3-4.15l.18-.26L55.12 6.73a11.33 11.33 0 0 1 8.93-4.34Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M64.05 2.39h18.26a8.55 8.55 0 0 1 2.92.51l.36.13 18.51 8a1.25 1.25 0 0 1-.88 2.34l-.12-.05-18.48-8a6 6 0 0 0-2-.44H64.06a1.25 1.25 0 0 1-.13-2.49ZM47.5 6.25a33.5 33.5 0 0 1 8.09 1 1.253 1.253 0 1 1-.61 2.43 30.66 30.66 0 0 0-6.79-.92H24.56a1.25 1.25 0 0 1-.13-2.49H47.5ZM31.5 44.35a6.75 6.75 0 0 1 5.56 2.92l.15.22L48 64.42a4.2 4.2 0 0 0 5.78 1.43 4.38 4.38 0 0 0 1.63-5.61 1.253 1.253 0 0 1 2.21-1.18 6.89 6.89 0 0 1-2.58 9 6.7 6.7 0 0 1-9-2.07l-.13-.21-10.8-16.9a4.26 4.26 0 0 0-3.37-2h-7.18a1.25 1.25 0 0 1-.13-2.49h7ZM103.72 50.47a1.25 1.25 0 0 1 1.26 1.24 1.27 1.27 0 0 1-1.13 1.29h-13a1.252 1.252 0 0 1-.13-2.5h13Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M24.1 0a1.25 1.25 0 0 1 1.24 1.12v51.36a1.26 1.26 0 0 1-1.12 1.25h-23a1.25 1.25 0 0 1-.13-2.49h21.76V2.5H1.37A1.26 1.26 0 0 1 .12 1.38v-.13A1.24 1.24 0 0 1 1.24 0H24.1Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M14.42 40.56a3.66 3.66 0 1 1-3.65-3.66 3.65 3.65 0 0 1 3.65 3.66"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#ffb81c"
          d="M10.77 35.65a4.91 4.91 0 1 0 4.9 4.91 4.91 4.91 0 0 0-4.9-4.91Zm0 2.5a2.41 2.41 0 1 1-2.42 2.41 2.4 2.4 0 0 1 2.42-2.41Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#0e497b"
          d="M126.58 4.41a1.25 1.25 0 0 1 .13 2.49H105.1v48.74h21.6a1.25 1.25 0 0 1 1.24 1.13v.12a1.26 1.26 0 0 1-1.12 1.25h-23a1.24 1.24 0 0 1-1.24-1.12V5.66a1.24 1.24 0 0 1 1.12-1.24h22.86Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M120.81 44.59a3.66 3.66 0 1 1-3.66-3.66 3.66 3.66 0 0 1 3.66 3.66"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#ffb81c"
          d="M117.15 39.68a4.92 4.92 0 1 0 4.91 4.91 4.91 4.91 0 0 0-4.91-4.91Zm0 2.5a2.42 2.42 0 1 1-2.41 2.41 2.4 2.4 0 0 1 2.41-2.41Z"
          className="icon-fill icon-accent"/>
      </svg>

    );
  }
}

Icon.displayName = 'HandshakeIcon';

export default Icon;
